// Build-time info injected via Vite env
export const BUILD_AT = import.meta.env.VITE_BUILD_AT || 'dev-local';
